import {
  HermesAlertIcon,
  HermesButton,
  HermesEmptyState,
  HermesRefreshIcon,
  HermesScreen,
} from "@/backoffice/hermes-ui";
import { useEffect } from "react";
import { isRouteErrorResponse, useNavigate, useRouteError } from "react-router";
import { BackofficeRoutes } from "../../constants/routes";

/** O detalhe técnico do erro, só para quem desenvolve (nunca para quem usa). */
const technicalDetail = (error: unknown): string => {
  if (isRouteErrorResponse(error)) return `${error.status} ${error.statusText}`;
  if (error instanceof Error) return `${error.name}: ${error.message}`;
  return String(error);
};

/**
 * Tela de erro do backoffice: quando uma tela quebra ao renderizar, o menu e o
 * cabeçalho continuam de pé e só o miolo troca por esta mensagem, sem texto
 * técnico. O erro de verdade vai para o console (e aparece aqui só em
 * desenvolvimento). Vale para qualquer tela do backoffice, sem cada uma precisar
 * se proteger.
 */
export const BackofficeRouteError = () => {
  const error = useRouteError();
  const navigate = useNavigate();

  useEffect(() => {
    console.error("[BackofficeRouteError]", error);
  }, [error]);

  return (
    <HermesScreen className="flex h-full min-h-0 flex-col items-center justify-center overflow-y-auto p-4 md:p-6">
      <div className="bg-hermes-card w-full max-w-lg rounded-3xl">
        <HermesEmptyState
          icon={<HermesAlertIcon />}
          title="Algo deu errado nesta tela"
          description="Não foi possível mostrar esta tela agora. Tente de novo; se continuar, avise o time de tecnologia."
          action={
            <div className="mt-1 flex flex-wrap justify-center gap-2">
              <HermesButton
                variant="primary"
                onClick={() => window.location.reload()}
              >
                <HermesRefreshIcon />
                Tentar de novo
              </HermesButton>
              <HermesButton
                variant="outline"
                onClick={() => navigate(BackofficeRoutes.ROOT)}
              >
                Voltar ao início
              </HermesButton>
            </div>
          }
        />
        {import.meta.env.DEV ? (
          <pre className="text-hermes-muted-fg mx-6 mb-6 overflow-x-auto rounded-xl p-3 text-xs whitespace-pre-wrap">
            {technicalDetail(error)}
          </pre>
        ) : null}
      </div>
    </HermesScreen>
  );
};
